module.exports = __webpack_public_path__ + "static/media/report_feedback_girl2.df8511e2.png";